import { Link } from "react-router";
import { Modal } from "semantic-ui-react";
import { useDisclosure } from "@iscr/xAppLib/Hooks/useDisclosure";
import { cls } from "@iscr/views/NUI/utils";

const InfoIcon = ({light}) => {
	return <svg xmlns="http://www.w3.org/2000/svg" width="38" height="38" viewBox="0 0 38 38" fill="none">
		<g clipPath="url(#clip0_25245_12658)">
			<ellipse cx="19" cy="19" rx="11" ry="11" className={`fill-[#4D93F6]  ${light && "lg:fill-is2-blue"}`}/>
			<path d="M19 8C22.0375 8 24.7875 9.23148 26.7782 11.2218C28.7685 13.2121 30 15.9625 30 19C30 22.0375 28.7685 24.7879 26.7782 26.7782C24.7875 28.7685 22.0375 30 19 30C15.9625 30 13.2125 28.7685 11.2218 26.7782C9.23148 24.7875 8 22.0375 8 19C8 15.9625 9.23148 13.2125 11.2218 11.2218C13.2125 9.23148 15.9625 8 19 8ZM18.572 14.9193C18.572 14.7354 18.6047 14.5643 18.6696 14.4075C18.734 14.2515 18.8316 14.1093 18.9613 13.9817C19.0902 13.8549 19.2316 13.7582 19.3841 13.6938C19.5375 13.6293 19.7025 13.5958 19.8791 13.5958C20.0562 13.5958 20.2212 13.6293 20.3729 13.6934C20.525 13.7582 20.6642 13.8549 20.7918 13.9825C20.9186 14.1102 21.0135 14.2515 21.0771 14.4084C21.1411 14.5643 21.1725 14.7354 21.1725 14.9193C21.1725 15.0984 21.1411 15.2664 21.0775 15.4216C21.0139 15.5763 20.9194 15.7198 20.7918 15.85C20.6655 15.9802 20.5263 16.0786 20.3741 16.1439C20.222 16.2087 20.057 16.2423 19.8791 16.2423C19.6978 16.2423 19.5294 16.2096 19.3743 16.1452C19.2204 16.0803 19.0795 15.9823 18.9519 15.8534C18.8255 15.7236 18.7302 15.581 18.667 15.425C18.6034 15.2695 18.572 15.101 18.572 14.9193ZM19.1478 22.5746C19.1001 22.7452 19.0039 23.0799 19.2896 23.0799C19.3515 23.0799 19.4301 23.0451 19.5242 22.9768C19.6261 22.9033 19.7429 22.7916 19.8736 22.6437C20.0063 22.4934 20.1451 22.315 20.2891 22.1101C20.4321 21.9055 20.583 21.6709 20.7398 21.4093C20.7557 21.3813 20.7927 21.3719 20.821 21.3886L21.3521 21.7831C21.3779 21.8016 21.3835 21.8368 21.3671 21.863C21.1227 22.2875 20.8756 22.6584 20.6255 22.975C20.3741 23.2934 20.1189 23.5581 19.8607 23.767L19.8564 23.7695C19.5977 23.9792 19.3326 24.1369 19.061 24.2426C18.3056 24.5352 17.112 24.4875 16.7699 23.6054C16.5542 23.0485 16.7313 22.4156 16.9014 21.8707L17.7591 19.2737C17.8141 19.0769 17.8832 18.8604 17.9082 18.658C17.9498 18.3198 17.8012 18.1011 17.4329 18.1011H16.6831C16.6505 18.1011 16.6238 18.0745 16.6238 18.0418L16.6273 18.0212L16.8241 17.3045C16.8309 17.2778 16.8554 17.2598 16.8821 17.2606L20.7114 17.1407C20.7441 17.1395 20.772 17.1652 20.7733 17.1979L20.7703 17.2164L19.1478 22.5746ZM25.9498 12.0502C24.1713 10.2718 21.7139 9.17133 19 9.17133C16.2861 9.17133 13.8287 10.2718 12.0502 12.0502C10.2718 13.8287 9.17133 16.2861 9.17133 19C9.17133 21.7139 10.2718 24.1713 12.0502 25.9498C13.8287 27.7282 16.2861 28.8287 19 28.8287C21.7139 28.8287 24.1713 27.7282 25.9498 25.9498C27.7282 24.1713 28.8287 21.7139 28.8287 19C28.8287 16.2861 27.7282 13.8287 25.9498 12.0502Z" fill="white"/>
		</g>
		<defs>
			<clipPath id="clip0_25245_12658">
			<rect width="38" height="38" fill="white"/>
			</clipPath>
		</defs>
	</svg>
}


export function WaitTimeInfoModal({avg_wait, avg_wait_req, light}) {
	const modal = useDisclosure();
	const trigger = <Link to="#" className="flex items-center justify-center h-[38px] w-[38px] rounded-full absolute -top-4 -right-4 block z-10" onClick={modal.onOpen}><InfoIcon light={light} /></Link>;

	const info_data = [
		{
			title: "Consultations",
			time: `Estimated wait time: ~${avg_wait} minutes`,
			info: ["Standard doctor consultations", "Prescription requests for new medications, scripts with repeats or multiple script requests", "Multi-day medical certificates", "Specialist referrals that are not listed"],
			extra:"*Wait time is estimated. Your time may vary based on demand."
		},
		{
			title: "Online requests",
			time: `Estimated wait time: ~${avg_wait_req} minutes`,
			info: ["Single-day medical certificates", "Single prescription requests with no repeats", "Pathology referrals", "Listed specialist referrals"],
			extra:"*Wait time is estimated. Your time may vary based on demand."
		},
		{
			title: "Other services",
			time: "The following consultation wait-times cannot be estimated. In general you will be called on the same day of your booking.",
			info: ["Weight management", "Menopause"],
		}
	]

	return (
		<Modal trigger={trigger} open={modal.isOpen} onClose={modal.onClose} onOpen={modal.onOpen} closeIcon size="small">
			<Modal.Header>
				Wait-time information
			</Modal.Header>

			<Modal.Content className="!px-6 !pt-8 pb-3">
				{info_data.map((d, i) => {
					return <div key={i} className="mb-6 last:mb-0">
							<div>
								<div className="bg-is2-blue text-white font-medium rounded-t-lg py-3 px-2">{d?.title}</div>
								<div className={cls(i === 2 ? "text-is2-gray-700 bg-is2-blue-100" : "text-white bg-is2-green-750", "text-base p-2")}>{d?.time}</div>
								{d?.info.map((n, i) => <div key={i} className="text-base text-is2-gray-700 py-1 px-2 border-b border-l border-r border-is2-gray-200">{n}</div>)}
							</div>
							{d?.extra && <p className="text-is2-gray-body mt-3">{d.extra}</p>}
						</div>
				})}
			</Modal.Content>
		</Modal>
	);
}

